import React, { Component } from 'react';
import PropTypes from 'prop-types';
import PublishButton from './PublishButton';
import PreviewButton from './PreviewButton';
import ProfileErrors from './ProfileErrors';
import UnpublishButton from './UnpublishButton';

export default class PublishContainer extends Component {
    static propTypes = {
        onPreviewClick: PropTypes.func.isRequired,
        onRequestPublish: PropTypes.func.isRequired,
        onRequestUnpublish: PropTypes.func.isRequired,
        profile: PropTypes.shape({
            isSaving: PropTypes.bool,
            profile: PropTypes.shape({
                id: PropTypes.number.isRequired,
                status: PropTypes.string.isRequired,
            }).isRequired,
        }).isRequired,
        profileErrors: PropTypes.object,
    };

    static defaultProps = {};

    state = {};

    render() {
        const isPublishing =
            this.props.profile.isSaving &&
            this.props.profile.profile.status === 'INACTIVE';
        const isUnpublishing =
            this.props.profile.isSaving &&
            this.props.profile.profile.status === 'ACTIVE';

        return (
            <section className="panel">
                <ProfileErrors profileErrors={this.props.profileErrors} />
                <PreviewButton
                    id={this.props.profile.profile.id}
                    onPreviewClick={this.props.onPreviewClick}
                    status={this.props.profile.profile.status}
                />
                <UnpublishButton
                    isSaving={this.props.profile.isSaving}
                    onRequestUnpublish={this.props.onRequestUnpublish}
                    status={this.props.profile.profile.status}
                />
                <PublishButton
                    hasErrors={!!Object.keys(this.props.profileErrors).length}
                    isSaving={this.props.profile.isSaving}
                    onRequestPublish={this.props.onRequestPublish}
                    profileId={this.props.profile.profile.id}
                    status={this.props.profile.profile.status}
                />
                {isPublishing && <p>Publiserer profilen...</p>}
                {isUnpublishing && <p>Avpubliserer profilen...</p>}
            </section>
        );
    }
}
